import * as React from "react";

const Integrations = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="svg1"
    width="24"
    height="24"
    version="1.1"
    viewBox="0 0 6.35 6.35"
  >
    <g
      id="layer8"
      fill="none"
      fillOpacity="1"
      stroke="#000"
      strokeDasharray="none"
      strokeDashoffset="3.477"
      strokeLinejoin="miter"
      strokeOpacity="1"
      strokeWidth="0.4"
    >
      <path
        id="path27"
        strokeLinecap="butt"
        d="M3.175 1.787v.87a1.047 1.047 135 0 1-1.047 1.047H1.84A1.047 1.047 45 0 1 .794 2.657v-.87a.2.2 135 0 1 .2-.2h1.981a.2.2 45 0 1 .2.2Z"
        opacity="1"
      ></path>
      <path
        id="path28"
        strokeLinecap="round"
        d="M1.984 3.704v1.323a.794.794 45 0 0 .794.794h.397a.794.794 135 0 0 .794-.794v-.53a.794.794 135 0 1 .793-.793h1.059"
        opacity="1"
      ></path>
      <path
        id="path29"
        strokeLinecap="round"
        d="M1.323 1.587V.53"
        opacity="1"
      ></path>
      <path
        id="path30"
        strokeLinecap="round"
        d="M2.646 1.587V.53"
        opacity="1"
      ></path>
    </g>
  </svg>
);

export default Integrations;
